export default {
  home: 'Hello',
  switchLang: '中文',
};
